// 引入 Vue 核心库
import Vue from 'vue'

// 引入 vue-router 路由插件（用于页面跳转）
import Router from 'vue-router'

// 引入各个页面组件（@ 代表 src 文件夹）
import Login from '@/views/Login'      // 登录页面
import Home from '@/views/Home'        // 主界面（侧边栏+内容区）
import Welcome from '@/views/Welcome' // 首页/数据概览
import User from '@/views/User'        // 用户管理页面
import Goods from '@/views/Goods'      // 商品管理页面
import Order from '@/views/Order'      // 订单管理页面

// 让 Vue 全局使用路由功能
Vue.use(Router)

// 创建路由实例并配置路由规则
const router = new Router({
  // 路由配置数组：所有页面跳转规则都写在这里
  routes: [
    // 1. 默认根路径 → 重定向到登录页
    { path: '/', redirect: '/login' },

    // 2. 登录页面路由
    { path: '/login', component: Login },

    // 3. 主界面路由（包含侧边栏 + 内容区）
    {
      path: '/home',
      component: Home,
      redirect: '/welcome', // 进入 home 自动跳转到 welcome 首页
      children: [            // 子路由：在 Home 内部的 <router-view> 显示
        { path: '/welcome', component: Welcome }, // 首页
        { path: '/user', component: User },       // 用户管理
        { path: '/goods', component: Goods },     // 商品管理
        { path: '/order', component: Order }      // 订单管理
      ]
    }
  ]
})

// ===================== 路由守卫（全局登录拦截） =====================
// 作用：所有页面跳转前都会先执行这里，用于判断是否登录
router.beforeEach((to, from, next) => {
  // to: 要去的页面
  // from: 从哪个页面来
  // next: 必须调用，允许跳转

  // 从 sessionStorage 中获取 token（登录成功后保存的凭证）
  const token = sessionStorage.getItem('token')

  // 如果没有 token（未登录），且要去的页面不是登录页
  // 强制跳转到登录页，禁止访问需要权限的页面
  if (!token && to.path !== '/login') return next('/login')

  // 正常放行，允许跳转
  next()
})

// 导出路由实例，在 main.js 中挂载到 Vue 根实例
export default router